import React, { useState, useEffect } from "react";
import AchatForm from "../../Components/Achat/AchatForm";
import Button from "react-bootstrap/Button";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  findAchatsBySocieteApi,
  ListAchat,
  ListDetailAchats,
  findDetailAchatsBySocieteApi,
  insertListAchatApi,
} from "../../_App/Redux/Slices/achat/achatSlice";
import {
  findParametrageApi,
  ListParametrges,
} from "../../_App/Redux/Slices/AppParametrages/parametrage/parametrageSlice";
import AchatTable from "../../Components/Achat/AchatTable";
import {
  SelectedOrganisationId,
  selectedAutorisations,
  societeId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import Navbar from "../../_Layouts/Navbar/Navbar";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastSuccess } from "../../Shared/Toasts/ToastSuccess";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import { Modal } from "react-bootstrap";
import axios from "axios";

export default function AchatPage() {
  const { t } = useTranslation();
  const [file, setfile] = useState<File | undefined>();

  const currentOrganisation = useAppSelector(SelectedOrganisationId);
  const societe = useAppSelector(societeId);

  const [ShowModalAchat, setSShowModalAchat] = useState(false);
  const [ShowModalProductDetail, setSShowModalProductDetail] = useState(false);
  const [ShowModalDetailAchat, setShowModalDetailAchat] = useState(false);
  const [ShowModalImport, setShowModalImport] = useState(false);
  const [achat, setachat] = useState(null);
  const dispatch = useAppDispatch();
  const listAchat = useAppSelector(ListAchat);
  const listDetailAchats = useAppSelector(ListDetailAchats);
  const listParametrges = useAppSelector(ListParametrges);
  useEffect(() => {
    if (societe) {
      dispatch(findAchatsBySocieteApi(societe));
      //  dispatch(findParametrageApi(null));
      dispatch(findDetailAchatsBySocieteApi(societe));
    }
  }, [dispatch, ShowModalDetailAchat]);
  const autorisations = useAppSelector(selectedAutorisations);
  const canViewAchats = autorisations?.CAN_VIEW_ACHATS;

  const navigate = useNavigate();

  useEffect(() => {
    if (!canViewAchats) {
      navigate("/unauthorized");
    }
  }, [canViewAchats, navigate]);
  const handleExcelImport = async () => {
    // Show SweetAlert with loading message
    Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await dispatch(insertListAchatApi({ file, societe }));
      if (response.payload.success) {
        ToastSuccess(t(response.payload.message));

        window.location.reload();
      } else {
        ToastWarning(t(response.payload.message));
      }
    } catch (error) {
      console.error("Error:", error);
      ToastWarning("An error occurred.");
    } finally {
      Swal.close();
    }
  };
  
const ExportFichier = () => {
  const path_server = process.env.REACT_APP_API_UPLOADS_URL;
  const url = `${path_server}FicherTelecharger/excelAchat.xlsx`;
  window.open(url, '_blank');
};

  return (
    <div>
      <Navbar />
      <div className="d-flex justify-content-end mb-3">
        <button
          onClick={() => {
            setachat(null);
            setSShowModalAchat(true);
          }}
          className="btn btn-primary-app"
        >
          {t("Ajouter Achat")}
        </button>
        <button
          onClick={() => {
            setShowModalImport(true);
          }}
          className="btn btn-primary-app"
        >
          {t("Import  Achat")}
        </button>{" "}
      </div>

      <AchatForm
        ShowModal={ShowModalAchat}
        setShowModal={setSShowModalAchat}
        ProductCaracteristique={achat}
        organisation_id={currentOrganisation}
        societe={societe}
      />
      <AchatTable
        t={t}
        ListAchats={listAchat}
        ListDetailAchats={listDetailAchats}
        organisation_id={currentOrganisation}
        setShowModalDetailAchat={setShowModalDetailAchat}
        ShowModalDetailAchat={ShowModalDetailAchat}
        ShowModalProductDetail={ShowModalProductDetail}
        setSShowModalProductDetail={setSShowModalProductDetail}
        societe={societe}
      />
      <Modal
        show={ShowModalImport}
        onHide={() => setShowModalImport(false)}
        className="modal-1"
        dialogClassName="modal-30w"
        backdropClassName="modal-backdrop-1"
      >
        <Modal.Header>
          {" "}
          <div className="  c-primary">{t("Achat par improt")} </div>
          <button className=" btn btn-primary" onClick={ExportFichier}>{t('Exporter fichier')}</button>
        </Modal.Header>
        <Modal.Body>
          <p className="c-primary">{t("Importer fichier")}</p>
          <p className="  form-control">
            <input type="file" onChange={(e) => setfile(e.target.files?.[0])} />
            <button onClick={handleExcelImport}>
              <i className="fas fa-file-import"></i>
            </button>
          </p>
        </Modal.Body>
      </Modal>
    </div>
  );
}
